import {Inject, Injectable} from "@angular/core";
import {BaseRestService} from "../../shared/rest/base-rest.service";
import {PropertyModel} from "../../shared/models/property.model";
import { HttpClient } from "@angular/common/http";
import {API_BASE_URL, API_VERSION} from "../../shared/shared.module";

@Injectable()
export class PropertyService extends BaseRestService<PropertyModel, PropertyModel, PropertyModel, PropertyModel, PropertyModel>{
  protected resourceName = 'properties';

  constructor(
    http: HttpClient,
    @Inject(API_BASE_URL) baseUrl: string,
    @Inject(API_VERSION) version: string
  ) {
    super(http, baseUrl, version);
  }
}
